import { render, staticRenderFns } from "./CashbookEntryTemplatesDesktop.vue?vue&type=template&id=06b9c563&"
import script from "./CashbookEntryTemplatesDesktop.vue?vue&type=script&lang=ts&"
export * from "./CashbookEntryTemplatesDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports